/**
 * Drop-in replacement for `import { toast } from 'sonner'` that adds
 * haptic feedback on iOS/Android automatically.
 *
 * Usage: replace `import { toast } from 'sonner'` with
 *        `import { toast } from '@/lib/haptic-toast'`
 */
import { toast as sonnerToast } from 'sonner';
import { hapticSuccess, hapticWarning, hapticLight } from '@/lib/haptics';

function withHaptics(originalFn, hapticFn) {
  return (...args) => {
    hapticFn();
    return originalFn(...args);
  };
}

export const toast = Object.assign(
  // Default toast (info) — light haptic
  withHaptics(sonnerToast, hapticLight),
  {
    success: withHaptics(sonnerToast.success, hapticSuccess),
    error: withHaptics(sonnerToast.error, hapticWarning),
    warning: withHaptics(sonnerToast.warning, hapticWarning),
    info: withHaptics(sonnerToast.info, hapticLight),
    // Pass through non-notification methods unchanged
    promise: sonnerToast.promise,
    loading: sonnerToast.loading,
    dismiss: sonnerToast.dismiss,
    message: sonnerToast.message,
    custom: sonnerToast.custom,
  },
);
